// Models
import { DependencyAddBlockedReason } from "../client/permissions/IAddDependencyPermissions";
import { Dependency } from "../client/planner/dependency/Dependency";
import { DefaultDependencyConstraint, getDependencyAddBlockedReasonMessage } from "../constants/DependencyConstants";
import { DependencyItemType } from "../service/planner/enumerations/IPlannerEnumerations";
/**
 * Create a temporary (not-yet-persisted) dependency. Item types default to Task and the constraint
 * defaults to the basic Finish-to-Start relationship; archival/creation info use the constructor
 * defaults (non-archived). Used where a dependency object is needed before one exists — e.g.
 * resolving permissions for an add-dependency flow.
 * @param sourceItemId Id of the source (predecessor) item
 * @param targetItemId Id of the target (successor) item
 * @param constraint The dependency constraint type (defaults to Finish-to-Start)
 */ export function createTempDependency(sourceItemId, targetItemId, constraint = DefaultDependencyConstraint) {
    return new Dependency({
        planId: "",
        sourceItemId,
        sourceItemType: DependencyItemType.Task,
        targetItemId,
        targetItemType: DependencyItemType.Task,
        constraint
    });
}
/**
 * Resolves the localized "cannot add dependency" message for a blocked reason, selecting the
 * per-task or per-plan limit as appropriate. Returns undefined when adding isn't blocked.
 * @param reason - The blocked reason, or null when adding is allowed
 * @param taskDependencyLimit - Maximum dependencies allowed per task
 * @param planDependencyLimit - Maximum dependencies allowed per plan
 */ export function resolveDependencyAddBlockedMessage(reason, taskDependencyLimit, planDependencyLimit) {
    if (reason == null) {
        return undefined;
    }
    const limit = reason === DependencyAddBlockedReason.TaskLimitReached ? taskDependencyLimit : reason === DependencyAddBlockedReason.PlanLimitReached ? planDependencyLimit : undefined;
    return getDependencyAddBlockedReasonMessage(reason, limit);
}
